define('collections/cd_roles',['require','collections/base','models/cd_role'],function (request) {
    var BaseCollection = require('collections/base');
    var Model = require("models/cd_role");
    return BaseCollection.extend({
        model : Model,
        url:"cd-roles.json"
    });
});
